import { isReferenceExtensionSupported } from '@bynder/image-gen-frontend-lib';

const DOCUMENT_EXTENSIONS = ['pdf'];
const UNSUPPORTED_DOCUMENT_EXTENSIONS = ['doc', 'docx'];

export function getAssetExtension(asset: unknown): string {
	if (typeof asset !== 'object' || asset === null) {
		return '';
	}

	return 'extensions' in asset && Array.isArray(asset.extensions) && asset.extensions.length
		? asset.extensions[0].toLowerCase()
		: '';
}

export function isUnsupportedDocumentExtension(extension: string): boolean {
	return UNSUPPORTED_DOCUMENT_EXTENSIONS.includes(extension.toLowerCase());
}

export type ReferenceAsset = {
	readonly databaseId: string;
	readonly thumbnail: string;
	readonly type?: 'image' | 'document';
};

export const INVALID_ASSET_FORMAT_ERROR_MESSAGE = 'UCV asset format is not supported';
export const INVALID_ASSET_ERROR_MESSAGE = 'Invalid asset format received from UCV';
export const INVALID_ASSET_PROPERTIES_ERROR_MESSAGE = 'UCV asset is missing required properties';

export function parseAsset(asset: unknown): ReferenceAsset {
	if (typeof asset !== 'object' || asset === null) {
		throw new Error(INVALID_ASSET_ERROR_MESSAGE);
	}

	const extension =
		'extensions' in asset && Array.isArray(asset.extensions) && asset.extensions.length
			? asset.extensions[0]
			: '';

	if (!extension || !isReferenceExtensionSupported(extension.toLowerCase())) {
		throw new Error(INVALID_ASSET_FORMAT_ERROR_MESSAGE);
	}

	const { databaseId, files } = asset as {
		databaseId: string;
		files: Record<string, { url: string }>;
	};

	if (typeof databaseId !== 'string' || !files) {
		throw new Error(INVALID_ASSET_PROPERTIES_ERROR_MESSAGE);
	}

	const type = DOCUMENT_EXTENSIONS.includes(extension.toLowerCase()) ? 'document' : 'image';

	return {
		databaseId,
		thumbnail: files.thumbnail?.url,
		type,
	};
}
